import React from 'react';
import { mount, route, compose, withView, redirect, map } from 'navi';
import { View } from 'react-navi';
import { PageLayout } from '@zen/common-app-parts';
import MainLayout from './components/layouts/MainLayout';
import SettingsNav from './components/navs/SettingsNav';
import PATHS from './paths';
import ConnectivitySettings from './pages/Settings/ConnectivitySettings';
import Issue from './pages/Issue/Issue';
import Redeem from './pages/Redeem';
import Cancel from './pages/Cancel/Cancel';
import VerifyEvent from './pages/VerifyEvent/VerifyEvent';
import VerifyNav from './components/navs/VerifyNav';
import VerifyAsset from './pages/VerifyAsset/VerifyAsset';
import VersionsSetting from './pages/Settings/VersionsSettings';

export default mount({
  '/': redirect(PATHS.DEFAULT),
  '/chain-switched': map(() => {
    return redirect(PATHS.DEFAULT);
  }),
  '/app': compose(
    withView(() => (
      <MainLayout>
        <View />
      </MainLayout>
    )),
    mount({
      '/settings': compose(
        withView(() => (
          <PageLayout nav={<SettingsNav />}>
            <View />
          </PageLayout>
        )),
        mount({
          '/': redirect(PATHS.SETTINGS_CONNECTIVITY),
          '/connectivity': route({
            title: 'Node Connectivity Settings',
            view: <ConnectivitySettings />,
          }),
          '/contracts': route({
            title: 'Contract Versions Settings',
            view: <VersionsSetting />,
          }),
        })
      ),
      '/issue': compose(
        withView(() => (
          <PageLayout>
            <View />
          </PageLayout>
        )),
        route({
          view: <Issue />,
        })
      ),
      '/redeem': compose(
        withView(() => (
          <PageLayout>
            <View />
          </PageLayout>
        )),
        route({
          view: <Redeem />,
        })
      ),
      '/cancel': compose(
        withView(() => (
          <PageLayout>
            <View />
          </PageLayout>
        )),
        mount({
          '/': route({
            view: <Cancel />,
          }),
        })
      ),
      '/verify': compose(
        withView(() => (
          <PageLayout nav={<VerifyNav />}>
            <View />
          </PageLayout>
        )),
        mount({
          '/': redirect(PATHS.VERIFY_ASSET),
          '/event': route({
            title: 'Event',
            view: <VerifyEvent />,
          }),
          '/asset': route({
            title: 'Asset',
            view: <VerifyAsset />,
          }),
        })
      ),
    })
  ),
});
